import { LoadedAdminData } from 'client/admin/shared/types';
import { getConfig } from 'client/shared/core/config';
import { COMMENTS_DATE_FORMAT, FeatureSettingType } from 'core';
import { StoreItemPublisherStatus } from 'graphql-schema/schema-types.g';
import moment from 'moment';
import React from 'react';

export const RemainingQuestionLimit: React.FC<{
  readonly adminData: LoadedAdminData;
  readonly showQueryLimit: boolean;
  readonly queryLimit: number;
  readonly queryCount?: number;
  readonly expiresAt?: Date;
}> = ({ adminData, showQueryLimit, queryCount, queryLimit }) => {
  const { activePublishingEntity: pub } = adminData.admin;
  const aiSetting = pub.featureSettings.find(
    (f) => f.featureSettingName === FeatureSettingType.AI_ASSISTANT
  );
  const expiresAt = aiSetting?.expiresAt;
  const tiers = adminData.admin.activePublishingEntity.storeTiers;
  const publisherOnFreeTier = tiers.find(
    (t) =>
      t.storeItem.key === FREE_TRIAL_TIER_KEY &&
      t.status === StoreItemPublisherStatus.ACTIVATED
  );
  const isFree =
    !pub.isEnterprise &&
    !!aiSetting &&
    aiSetting.enabledForPublisher &&
    publisherOnFreeTier;

  const freeTierSpan =
    isFree && expiresAt ? (
      <span>
        Free Polco Trial until {moment(expiresAt).format(COMMENTS_DATE_FORMAT)}
      </span>
    ) : null;
  const remainingQueryCount = queryCount === undefined ? 0 : queryLimit - queryCount;
  const questionCountSpan =
    remainingQueryCount <= 50 ? (
      <span>
        You have <b>{remainingQueryCount > 0 ? remainingQueryCount : 0}</b> question
        {remainingQueryCount === 1 ? '' : 's'} left to ask.
      </span>
    ) : null;

  return showQueryLimit && (freeTierSpan || questionCountSpan) ? (
    <div
      className={`pn-ai-assistant-query-count-banner font-size-sm d-flex flex-row justify-content-between align-items-center bg-brand-l px-4 py-2`}
    >
      <span>
        {freeTierSpan}
        {freeTierSpan && questionCountSpan ? <span>: </span> : null}
        {questionCountSpan}
      </span>
    </div>
  ) : null;
};

const config = getConfig();
const FREE_TRIAL_TIER_KEY = config.envFeatures.freeTrialTierKey;
